function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 4.5C14.5 4.5 16.5 6 16.5 9.5",
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 7H2C0.89543 7 0 7.89543 0 9V25C0 26.1046 0.89543 27 2 27H12C13.1046 27 14 26.1046 14 25V9C14 7.89543 13.1046 7 12 7Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 23.5C7.5 23.7761 7.27614 24 7 24V25C7.82843 25 8.5 24.3284 8.5 23.5H7.5ZM7 24C6.72386 24 6.5 23.7761 6.5 23.5H5.5C5.5 24.3284 6.17157 25 7 25V24ZM6.5 23.5C6.5 23.2239 6.72386 23 7 23V22C6.17157 22 5.5 22.6716 5.5 23.5H6.5ZM7 23C7.27614 23 7.5 23.2239 7.5 23.5H8.5C8.5 22.6716 7.82843 22 7 22V23ZM2 8H12V6H2V8ZM12 8C12.5523 8 13 8.44772 13 9H15C15 7.34315 13.6569 6 12 6V8ZM13 9V25H15V9H13ZM13 25C13 25.5523 12.5523 26 12 26V28C13.6569 28 15 26.6569 15 25H13ZM12 26H2V28H12V26ZM2 26C1.44771 26 1 25.5523 1 25H-1C-1 26.6569 0.343146 28 2 28V26ZM1 25V9H-1V25H1ZM1 9C1 8.44772 1.44772 8 2 8V6C0.343146 6 -1 7.34315 -1 9H1Z",
  fill: "white",
  mask: "url(#path-2-inside-1)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11 1C17 1 20 4.5 20 9.5M3 10H11V22H3V10Z",
  stroke: "white"
});

var SvgCoddPhone = function SvgCoddPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoddPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/codd-phone.760a8caa.svg";
export { ForwardRef as ReactComponent };